import React, { useEffect, useState } from 'react';
import {
    Box,
    Grid,
    Typography,
    useTheme,
    Dialog,
    Avatar,
    Chip,
    IconButton,
} from '@mui/material';
import PropTypes from 'prop-types';
import MDEditor from '@uiw/react-md-editor';
import { Close, Launch, PinDrop, Edit, Delete } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import ProductForm from './AddProductForm';

export default function ProductDetailModal({ product, open, onClose, role, onEdit, onDelete,user }) {
    const theme = useTheme();
    const { t, i18n } = useTranslation();

    

    const handleEditClick = () => {
        onEdit(product);
        onClose();
    };

    const handleDelete = () => {
        if (window.confirm(t('confirmDeleteProduct'))) {
            onDelete(product);
            onClose();
        }
    };



    return (
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="md"
                fullWidth
                PaperProps={{ sx: { borderRadius: 4 } }}
                dir={i18n.dir()}
            >
                <Box sx={{ position: 'relative', p: 2, height: '100%' }}>
                    <Box sx={{ position: 'sticky', top: 0, zIndex: 1,  pb: 2 }}>
                        <IconButton
                            onClick={onClose}
                            sx={{
                                position: 'absolute',
                                right: 0,
                                top: 0
                            }}
                        >
                            <Close />
                        </IconButton>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Typography variant="h4" fontWeight="700">
                                {product.product_name}
                            </Typography>
                            {role === "my_products" && (
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <IconButton
                                        onClick={handleEditClick}
                                        color="primary"
                                        size="small"
                                    >
                                        <Edit />
                                    </IconButton>
                                    <IconButton
                                        onClick={handleDelete}
                                        color="error"
                                        size="small"
                                    >
                                        <Delete />
                                    </IconButton>
                                </Box>
                            )}
                        </Box>
                    </Box>

                    <Box sx={{ overflowY: 'auto', maxHeight: 'calc(100vh - 64px)', pt: 2 }}>
                        <Grid container spacing={4}>
                            {/* Product Details Column */}
                            <Grid item xs={12} md={6}>
                                {/* <Avatar
                                    variant="rounded"
                                    src={product.product_image}
                                    sx={{
                                        width: '100%',
                                        height: 200,
                                        borderRadius: 3,
                                        objectFit: 'contain',
                                        mb: 3,
                                        boxShadow: theme.shadows[1]
                                    }}
                                /> */}
                                <img
                    src={product.product_image}
                    style={{
                        width: '100%',
                        height: 200,
                        borderRadius: 2,
                        objectFit: 'contain'
                    }}
                />

                                <Typography variant="h5" gutterBottom>
                                    {t('productDescription')}
                                </Typography>
                                <MDEditor.Markdown
                                    source={product.product_description}
                                    style={{
                                        backgroundColor: 'transparent',
                                        color: theme.palette.text.primary
                                    }}
                                />
                            </Grid>

                            {/* Owner Details Column */}
                            <Grid item xs={12} md={6}>
                                <Box sx={{
                                    p: 2,
                                    backgroundColor: theme.palette.background.default,
                                    borderRadius: 3,
                                    // boxShadow: theme.shadows[10]
                                }}>
                                    <Typography variant="h5" gutterBottom>
                                        {t('AboutCompany')}
                                    </Typography>

                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                                        <Avatar
                                            src={product.profile_pic || './profile_pic.png'}
                                            sx={{ width: 64, height: 64 }}
                                        />
                                        <Box>
                                            <Typography variant="h6">{product.name}</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {product.country}
                                            </Typography>
                                            <Chip
                                                icon={<PinDrop fontSize="small" />}
                                                label={`${t('StallNo')} ${product.stallNo}`}
                                                size="small"
                                                sx={{ mt: 1 }}
                                            />
                                        </Box>
                                    </Box>

                                    {product.bio && (
                                        <>
                                            <MDEditor.Markdown 
                                                source={product.bio}
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    color: theme.palette.text.primary
                                                }}
                                            />
                                        </>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Dialog>
          
    );
};

ProductDetailModal.propTypes = {
    product: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    role: PropTypes.string,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
};
